import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import {
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  RadioGroup,
} from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useHotelListSort } from "@tenant/hotels";
import clsx from "clsx";
import defaultStyles from "./Sort.module.scss";

export type HotelListSortComponentProps = PlatformComponentProps;

export const HotelListSort = ({
  children,
  className,
}: HotelListSortComponentProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.HotelListSort;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  const {
    context: { sortOptions, selectedSort },
    handlers: { getSortLabelKey, handleSortChange },
  } = useHotelListSort();

  return (
    <Popover>
      <PopoverTrigger className={clsx(cn("sort-button"), className)}>
        <span>
          <span className={cn("sort-label")}>
            {t("core-hotels.availabilityPage.sort.dropDownLabel")}
          </span>
          {getSortLabelKey(selectedSort)}
        </span>
        <Icon iconName={IconNameEnum.dropdownTriangle} />
      </PopoverTrigger>
      <PopoverContent
        className={clsx(cn("sort-content"), className)}
        align="end"
      >
        <RadioGroup
          options={sortOptions}
          selectedOption={selectedSort}
          onSelectValue={(value) => handleSortChange(value)}
          className={cn("radio-group")}
        />
        {children}
      </PopoverContent>
    </Popover>
  );
};
